import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import PatientInfo from '../../components/patient/PatientInfo';
import PatientData from '../../components/patient/PatientData';
import WoundList from '../../components/patient/WoundList';
import LoadingIcon from '../../components/shared/LoadingIcon';
import FPPContainer from '../fpp/FPPContainer';
import {
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
} from '../../constants/RoleConstants';

const FPPRoleWhiteList = [DOCTOR_ID, ASSISTANT_ID, NURSE_ID];

export class RecordDetailContainer extends Component {
  componentDidMount = async () => {
    const {
      actions: {
        fetchPatientDetail,
        createDangerAlert,
      },
      medicalRecordId,
    } = this.props;
    const result = await fetchPatientDetail(medicalRecordId);
    if (result !== true) {
      createDangerAlert(result.message);
    }
  }
  render() {
    const {
      router,
      medicalRecordId,
      actions,
      patient: {
        isPatientDetailLoading,
        patientDetail,
      },
      fpp,
      user: { profile: { roleId } },
    } = this.props;

    if (isPatientDetailLoading || Object.keys(patientDetail).length === 0) {
      return (
        <div className="col-md-12">
          <h1>
            {i18n.t('medicalRecord')}
          </h1>
          <p className="lead">
            {i18n.t('viewMedicalRecord')}
          </p>
          <hr />
          <div style={{ textAlign: 'center' }}>
            <LoadingIcon />
          </div>
        </div>
      );
    }
    return (
      <div className="col-md-12">
        <h1>
          {i18n.t('medicalRecord')}
        </h1>
        <p className="lead">
          {i18n.t('viewMedicalRecord')}
        </p>
        <hr />
        <PatientInfo {...this.props} />
        <PatientData {...this.props} />
        <WoundList {...this.props} />
        <FPPContainer
          router={router}
          actions={actions}
          patientUserId={patientDetail.userId}
          medicalRecordId={medicalRecordId}
          assessments={fpp.assessments}
          onExportPDF={this.onExportPDF}
          viewOnly={!FPPRoleWhiteList.includes(roleId)}
        />
      </div>
    );
  }
}

RecordDetailContainer.propTypes = {
  actions: PropTypes.shape({
    fetchPatientDetail: PropTypes.func.isRequired,
    createDangerAlert: PropTypes.func.isRequired,
  }).isRequired,
  medicalRecordId: PropTypes.string.isRequired,
  user: PropTypes.shape({
    profile: PropTypes.shape({
      roleId: PropTypes.number,
    }),
  }),
  patient: PropTypes.shape({
    isPatientDetailLoading: PropTypes.bool.isRequired,
    patientDetail: PropTypes.object.isRequired,
  }).isRequired,
  router: PropTypes.object.isRequired,
  fpp: PropTypes.shape({
    assessments: PropTypes.array.isRequired,
  }).isRequired,
};

RecordDetailContainer.defaultProps = {
  user: { profile: { roleId: null } },
};

export default connectActionsAndReducers(RecordDetailContainer);



// WEBPACK FOOTER //
// ./src/containers/record/RecordDetailContainer.js